import { App } from 'vue';
import { clients } from '@api/client';

const ClientPlugin = {
  install(app: App) {
    app.provide('$clients', clients);
  },
};

export default ClientPlugin;
